export default function initBuyNow() {
  document.body.addEventListener('click', async (e) => {}, true);
}
